const Spinner = () => {
  return(
    <div className="text-center bg-dark">
      <div className="spinner-border text-primary mt-3"/>  
    </div>
  );
};

export default Spinner;